import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

function GamesPage() {
  const navigate = useNavigate();

 const allGames = [
 { id: 1, title: "Katana Fruits", image: "/assets/gamescard/fruit-ninja.png", link: "http://ghanagameium.com/katana-fruits/" },
  { id: 2, title: "Water Craft", image: "/assets/gamescard/watercraft.png", link: "http://ghanagameium.com/watercraft-rush/" },
  { id: 3, title: "Penalty kicks", image: "/assets/gamescard/penaltykicks.png", link: "http://ghanagameium.com/penalty-kicks/" },
  { id: 4, title: "Duck Shooter", image: "/assets/gamescard/duck-shooter.png", link: "http://ghanagameium.com/duck-shooter/" },
  { id: 5, title: "Ultimate Swish", image: "/assets/gamescard/ultimate-swish.png", link: "http://ghanagameium.com/ultimate-swish/" },
  { id: 6, title: "Marble Blast", image: "/assets/gamescard/marbleblast.png", link: "http://ghanagameium.com/marbleblast/" },

    {id: 7,
    title: "Word Puzzle",
    image: "/assets/gamescard/word-puzzle.png",
    link: "http://ghanagameium.com/word-puzzle/",
  },
  { id: 8, title: "Different Emoji", image: "/assets/gamescard/different-emoji.png",link: "http://ghanagameium.com/emoji-difference/"},
  { id: 9, title: "Fruit Skill", image: "/assets/gamescard/stick-fruit.png",link: "http://ghanagameium.com/fruit-skill/" },
  { id: 10, title: "Lucky Wheels", image: "/assets/gamescard/lucky-wheel.png",link: "http://ghanagameium.com/luckywheels/"},
  { id: 11, title: "Urban Crosser", image: "/assets/gamescard/urban-crosser.png",link: "http://ghanagameium.com/urban-crosser/" },
  { id: 12, title: "Guess The Quiz", image: "/assets/gamescard/guessquiz.png",link: "http://ghanagameium.com/engaging-emoji/" },

   {
    id: 13,
    title: "Gear Madness",
    image: "/assets/gamescard/gear-madness.png",
    link: "https://thegameio.com/gear-madness/",
  },
  { id: 14, title: "Traffic Racer", image: "/assets/gamescard/traffic-racer.png", link: "http://ghanagameium.com/traffic-racer/", },
  { id: 15, title: "Aero Rush", image: "/assets/gamescard/aero-rush.png" },
  { id: 16, title: "Formula Rush", image: "/assets/gamescard/formula-rush.png",link: "http://ghanagameium.com/formula-racing/",},
  { id: 17, title: "Roadmash Car", image: "/assets/gamescard/roadmash22.png",link: "http://ghanagameium.com/roadmash-car/" },
  { id: 18, title: "Fastlanego", image: "/assets/gamescard/fast-lane.png" },

  {
    id: 19,
    title: "puzzle master",
    image: "/assets/gamescard/puzzle-master.png",
    link: "http://ghanagameium.com/jigsaw-puzzle/",
  },
  { id: 20, title: "Genius", image: "/assets/gamescard/genius.png", link: "http://ghanagameium.com/genius/", },
  { id: 21, title: "Sudoku", image: "/assets/gamescard/sudoku.png", link: "http://ghanagameium.com/sudoku/", },
  { id: 22, title: "Slider Puzzle", image: "/assets/gamescard/sliderpuzzle.png", link: "http://ghanagameium.com/slider-puzzle/", },
  { id: 23, title: "Spelling Challenge", image: "/assets/gamescard/spellingchllange.png", link: "http://ghanagameium.com/spelling-challenge/", },
  { id: 24, title: "3D Maze", image: "/assets/gamescard/3dmaze.png", link: "http://ghanagameium.com/3dmaze/",},
  {
    id: 25,
    title: "Neon Pong",
    image: "/assets/gamescard/neonpong.png",
    link: "http://ghanagameium.com/ai-puzzle/",
  },
  { id: 26, title: "Connect Four Classic", image: "/assets/gamescard/connectfour.png", link: "http://ghanagameium.com/connect-four-classic/", },
  { id: 27, title: "Archery Master", image: "/assets/gamescard/shooting.png", link: "http://ghanagameium.com/shooting-game/", },
  { id: 28, title: "Water Sort", image: "/assets/gamescard/watersort.png", link: "http://ghanagameium.com/water-sort-puzzle/", },
  { id: 29, title: "Color Spinner", image: "/assets/gamescard/color-spinner.png", link: "http://ghanagameium.com/color-spinner/", },
  { id: 30, title: "Juicy Puzzle", image: "/assets/gamescard/juicy-puzzle.png", link: "http://ghanagameium.com/juicy-puzzle/",},
  { id: 31, title: "tetris-evolution", image: "/assets/gamescard/tetris-evolution.png", link: "http://ghanagameium.com/tetris-evolution/", },
  { id: 32, title: "Word Puzzle", image: "/assets/gamescard/word-puzzle.png", link: "http://ghanagameium.com/word-puzzle.jpg/", },
  { id: 33, title: "Guess The Quezz", image: "/assets/gamescard/guessquiz.png", link: "http://ghanagameium.com/engaging-emoji/", },
];


  // ✅ SAME CLICK HANDLER AS TRENDING
 const handleGameClick = (game) => {
  const isSubscribed = localStorage.getItem("isSubscribed") === "true";

  if (!isSubscribed) {
    Swal.fire({
      title: "🚫 Subscription Required",
      text: "Please subscribe to play games",
      icon: "warning",
      confirmButtonColor: "#ff003c",
      confirmButtonText: "Go to Subscribe",
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/signin");
      }
    });
    return;
  }

  if (game.link) {
    window.open(game.link, "_self");
  } else {
    navigate("/games");
  }
};

  return (
    <div className="bg-[#181820] min-h-screen overflow-x-hidden">

      {/* ================= BANNER ================= */}
      <section
        className="relative h-[280px] sm:h-[340px] md:h-[420px] lg:h-[420px] w-full bg-cover bg-center"
        style={{ backgroundImage: "url('/assets/banner-about-bg.webp')" }}
      >
      {/* 🔴 RED COLOR OVERLAY */}
  <div className="absolute inset-0 bg-gradient-to-r from-[#ff003c]/40 to-[#6a00ff]/40 mix-blend-overlay"></div>

        {/* center glow image */}
        <img
          src="/assets/game-banner-illus-2.png"
          alt="center illustration"
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
          w-[180px] sm:w-[220px] md:w-[280px] opacity-50 z-20 hidden sm:block"
        />

        <div className="relative z-30 h-full flex items-center">
          <div className="max-w-[1400px] mx-auto w-full px-4 sm:px-6 lg:px-10">
            <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-6">

              {/* LEFT CONTENT */}
              <div className="text-white text-center md:text-left">

                <div className="relative inline-block">
                  <img
                    src="/assets/images/game-banner-illus-1.png"
                    alt="decoration"
                    className="absolute -left-[70px] top-1/2 -translate-y-1/2 w-[300px] hidden md:block"
                  />

                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mt-6 md:mt-10">
              Games
            </h2>
                </div>

                 <div className="flex gap-2 text-sm text-gray-300 mt-3">
              <span>Home</span>
              <span>›</span>
              <span>Pages</span>
              <span>›</span>
              <span className="text-[#ff003c] font-semibold">Games</span>
            </div>
              </div>

              {/* RIGHT IMAGES */}
              <div className="relative hidden md:block h-[420px]">

                <img
                  src="/assets/game-banner-illus-4.webp"
                  alt="character"
                  className="absolute bottom-0 right-[180px] w-[180px] lg:w-[200px] drop-shadow-2xl"
                />

                <img
                  src="/assets/game-banner-illus-3.webp"
                  alt="trophy"
                  className="absolute bottom-[80px] right-[20px] w-[160px] lg:w-[180px] drop-shadow-xl"
                />
              </div>

            </div>
          </div>
        </div>
      </section>


      {/* ================= GAMES LIST ================= */}
       <div className="pt-14 pb-40">
        <div className="container mx-auto px-4 sm:px-6 lg:px-10">

          <h2 className="text-center text-3xl font-bold text-white mb-14">
            <span className="text-[#ff003c] font-semibold">Games</span>
          </h2>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-6 lg:gap-8">
            {allGames.map((res) => (
              <div
                key={res.id}
                className="group flex flex-col h-full cursor-pointer"
                onClick={() => handleGameClick(res)}
              >
                <div className="overflow-hidden rounded-2xl border-2 border-[#36363e] group-hover:border-yellow-500 transition-all duration-300 h-[180px]">
                  <img
                    src={res.image}
                    alt={res.title}
                    className="w-full h-full object-fill group-hover:scale-105 transition-transform duration-500"
                  />
                </div>

                <h3 className="mt-4 text-center text-white text-lg font-semibold flex-grow flex items-center justify-center">
                  {res.title}
                </h3>
              </div>
            ))}
          </div>

        </div>
      </div>

    </div>
  );
}

export default GamesPage;
